<template>
	<footer class="footer">
		<div class="footer-container">
			<!-- 主要内容区域 -->
			<div class="footer-content">
				<!-- 左侧联系信息区域 -->
				<div class="contact-section">
					<!-- Logo -->
					<div class="logo-section">
						<div class="logo"></div>
					</div>

					<!-- 联系信息 -->
					<div class="contact-info">
						<div class="contact-item">
							<img class="contact-icon" alt="Phone" src="/img/vuesax-bold-call-calling.svg" />
							<span class="contact-text">15992646535</span>
						</div>

						<div class="contact-item">
							<img class="contact-icon" alt="Location" src="/img/vector-3.svg" />
							<span class="contact-text">
								广东省珠海市香洲区吉大路海滨南路52号中信南航国际广场15楼
							</span>
						</div>
					</div>
				</div>

				<!-- 中间微信二维码区域 -->
				<div class="qr-section">
					<div class="qr-code">
						<img class="qr-image" alt="QR Code" src="/img/image-509.png" />
					</div>
					<div class="qr-text">官方微信</div>
				</div>

				<!-- 右侧导航区域 -->
				<div class="navigation-section">
					<ul class="footer-nav">
						<li class="nav-block">
							<h4 class="nav-title" @click="navigateToAboutUs">关于朗乾</h4>
							<a class="nav-link" @click="navigateToAboutUs">朗乾介绍</a>
							<a class="nav-link" @click="navigateToAboutUs">朗乾发展</a>
							<a class="nav-link" @click="navigateToAboutUs">朗乾文化</a>

						</li>

						<li class="nav-block">
							<h4 class="nav-title" @click="navigateToTeamSpotlight">团队风采</h4>
							<a class="nav-link" @click="navigateToTeamSpotlight">团队介绍</a>
							<a class="nav-link" @click="navigateToTeamSpotlight">主要律师</a>
							<a class="nav-link" @click="navigateToTeamSpotlight">职业团队</a>
						</li>

						<li class="nav-block">
							<h4 class="nav-title" @click="navigateToNewsUpdates">新闻资讯</h4>
							<a class="nav-link" @click="navigateToNewsUpdates1">郎乾动态</a>
							<!--<a class="nav-link" @click="navigateToNewsUpdates2">行业公告</a>-->
							<!--<a class="nav-link" @click="navigateToNewsUpdates3">业内动态</a>-->
						</li>

						<li class="nav-block">
							<h4 class="nav-title" @click="navigateToPartyBuilding">党建信息</h4>
							<a class="nav-link" @click="navigateToPartyBuilding">党建动态</a>
							<a class="nav-link" @click="navigateToPartyBuilding">党员风采</a>
						</li>

						<li class="nav-block">
							<h4 class="nav-title" @click="navigateToContactUs">联系我们</h4>
							<a class="nav-link" @click="navigateToContactUs">朗乾地址</a>
							<a class="nav-link" @click="navigateToContactUs">线上留言</a>
						</li>
					</ul>
				</div>
			</div>

			<!-- 版权信息 -->
			<div class="copyright">
				©2016-2021 朗乾律师事务所 版权所有 粤ICP备2021118342号-1
			</div>
		</div>
	</footer>
</template>

<script>
	import router from '../router';

	export default {
		name: "Footer",
		methods: {
			navigateToAboutUs() {
				router.push({
					path: '/about'
				})
			},
			navigateTohome() {
				router.push({
					path: '/'
				})
			},
			navigateToNewsUpdates() {
				router.push({
					path: '/NewsUpdatesPage'
				})
			},
			navigateToNewsUpdates1() {
				router.push({
					path: '/NewsUpdatesPage',
					query: {
						index: 0,
					}
				})
			},
			navigateToNewsUpdates2() {
				router.push({
					path: '/NewsUpdatesPage',
					query: {
						index: 1,
					}
				})
			},
			navigateToNewsUpdates3() {
				router.push({
					path: '/NewsUpdatesPage',
					query: {
						index: 2,
					}
				})

			},
			navigateToPartyBuilding() {
				router.push({
					path: '/PartyBuildingPage'
				})
			},
			navigateToContactUs() {
				router.push({
					path: '/ContactUsPage'
				})
			},
			navigateToJoinUs() {
				router.push({
					path: '/JoinUsPage'
				})
			},
			navigateToTeamSpotlight() {
				router.push({
					path: '/TeamSpotlightPage'
				})
			}
		}
	};
</script>

<style scoped>
	/* ===== 基础样式重置 ===== */
	* {
		box-sizing: border-box;
	}

	/* ===== Footer主容器 ===== */
	.footer {
		background-color: #FFF6EE;
		width: 100%;
		min-height: 236px;
	
	}

	.footer-container {
		width: 1062px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		min-height: 236px;
	}

	/* ===== 主要内容区域 ===== */
	.footer-content {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		padding: 40px 0 20px 0;
		flex: 1;
		gap: 2rem;
	}

	/* ===== 左侧联系信息区域 ===== */
	.contact-section {
		display: flex;
		flex-direction: column;
		gap: 1.5rem;
		flex-shrink: 0;
		min-width: 300px;
	}

	/* Logo区域 */
	.logo-section {
		margin-bottom: 1rem;
	}

	.logo {
		background-image: url(/img/logo1-1-1.png);
		background-position: center;
		background-size: contain;
		background-repeat: no-repeat;
		height: 63px;
		width: 263px;
	}

	/* 联系信息 */
	.contact-info {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	.contact-item {
		display: flex;
		align-items: flex-start;
		gap: 0.5rem;
	}

	.contact-icon {
		width: 20px;
		height: 20px;
		flex-shrink: 0;
		margin-top: 0.125rem;
	}

	.contact-text {
		color: #333;
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 12px;
		font-weight: 400;
		line-height: 1.4;
		letter-spacing: 0.6px;
		width:50%;
	}

	/* ===== 中间微信二维码区域 ===== */
	.qr-section {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.5rem;
		flex-shrink: 0;
		margin-top: 81px;
		margin-left: -168px;
		
		/* 与Logo对齐 */
	}

	.qr-code {
		width: 72px;
		height: 72px;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid #f3f3f3;
		border-radius: 4px;
	}

	.qr-image {
		width: 56px;
		height: 56px;
	}

	.qr-text {
		color: #333;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 0.625rem;
		font-weight: 500;
		opacity: 0.3;
		text-align: center;
	}

	/* ===== 右侧导航区域 ===== */
	.navigation-section {
		flex: 1;
		display: flex;
		justify-content: flex-end;
	}

	.footer-nav {
		display: flex;
		gap: 0.5rem;
		/* 从2.5rem缩小到1.5rem */
		list-style: none;
		margin: 0;
		padding: 0;
		/* flex-wrap: wrap; */
	}

	.nav-block {
		display: flex;
		flex-direction: column;
		min-width: 80px;
		/* 从120px缩小到100px */
	}

	.nav-title {
		color: #333;
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 1rem;
		font-weight: 400;
		margin: 0 0 1.5rem 0;
		cursor: pointer;
		transition: color 0.3s ease;
	}

	.nav-title:hover {
		color: #7a3529;
	}

	.nav-link {
		color: #333;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 0.875rem;
		font-weight: 500;
		opacity: 0.4;
		line-height: 1.625rem;
		cursor: pointer;
		transition: all 0.3s ease;
		text-decoration: none;
		margin-bottom: 0.5rem;
	}

	.nav-link:hover {
		opacity: 1;
		color: #7a3529;
	}

	/* ===== 版权信息 ===== */
	.copyright {
		text-align: center;
		color: #333;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 0.625rem;
		font-weight: 500;
		opacity: 0.3;
		padding: 1rem 0 2rem 0;
		border-top: 1px solid #f0f0f0;
	}

	/* ===== 响应式设计 ===== */

	/* 大屏幕 (≥1200px) */
	@media (min-width: 1000px) {
		.footer-container {
			/* padding: 0 40px; */
		}

		.footer-content {
			gap: 3rem;
		}

		.footer-nav {
			gap: 2rem;
			/* 从3rem调整到2rem */
		}
	}

	/* 中等屏幕 (768px - 1199px) */
	@media (max-width: 1199px) and (min-width: 768px) {
		.footer-content {
			gap: 1.5rem;
		}

		.contact-section {
			min-width: 250px;
		}

		.logo {
			width: 220px;
			height: 53px;
		}

		.footer-nav {
			gap: 1.25rem;
			/* 从2rem调整到1.25rem */
		}

		.nav-block {
			min-width: 90px;
			/* 从100px调整到90px */
		}
	}

	/* 小屏幕 (<768px) */
	@media (max-width: 767px) {
		.footer-container {
			padding: 0 15px;
		}

		.footer-content {
			flex-direction: column;
			gap: 2rem;
			padding: 30px 0 15px 0;
		}

		.contact-section {
			min-width: auto;
			width: 100%;
			align-items: center;
		}

		.logo {
			width: 200px;
			height: 48px;
		}

		.contact-info {
			width: 100%;
			max-width: 400px;
		}

		.qr-section {
			margin-top: 0;
			order: 2;
		}

		.navigation-section {
			width: 100%;
			justify-content: center;
			order: 3;
		}

		.footer-nav {
			justify-content: center;
			gap: 1.5rem;
		}

		.nav-block {
			min-width: 100px;
			text-align: center;
		}

		.nav-title {
			font-size: 0.875rem;
			margin-bottom: 1rem;
		}

		.nav-link {
			font-size: 0.75rem;
			line-height: 1.5rem;
		}

		.copyright {
			padding: 0.75rem 0 1.5rem 0;
			font-size: 0.5rem;
		}
	}

	/* 超小屏幕 (<480px) */
	@media (max-width: 479px) {
		.footer-container {
			padding: 0 10px;
		}

		.footer-content {
			gap: 1.5rem;
			padding: 20px 0 10px 0;
		}

		.logo {
			width: 180px;
			height: 43px;
		}

		.contact-text {
			font-size: 0.625rem;
		}

		.footer-nav {
			gap: 1rem;
			flex-direction: column;
			align-items: center;
		}

		.nav-block {
			min-width: auto;
			width: 100%;
			max-width: 200px;
		}

		.nav-title {
			font-size: 0.75rem;
			margin-bottom: 0.75rem;
		}

		.nav-link {
			font-size: 0.625rem;
			line-height: 1.25rem;
			margin-bottom: 0.25rem;
		}

		.qr-code {
			width: 60px;
			height: 60px;
		}

		.qr-image {
			width: 48px;
			height: 48px;
		}

		.copyright {
			padding: 0.5rem 0 1rem 0;
			font-size: 0.5rem;
		}
	}

	/* ===== 动画效果 ===== */
	.nav-title,
	.nav-link {
		transition: all 0.3s ease;
	}

	.contact-item {
		transition: transform 0.3s ease;
	}

	.contact-item:hover {
		transform: translateX(4px);
	}

	/* ===== 滚动条样式 ===== */
	.footer-nav::-webkit-scrollbar {
		width: 4px;
	}

	.footer-nav::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 2px;
	}

	.footer-nav::-webkit-scrollbar-thumb {
		background: #7a3529;
		border-radius: 2px;
	}

	.footer-nav::-webkit-scrollbar-thumb:hover {
		background: #5a2a1f;
	}
</style>